module.exports = function handleSubmitError(form, data) {
	if(form.attr('id') === 'loginCreateAccessForm') {
		if(data.responseJSON.msg === 'already.enabled') {
		$('#step1').addClass('hidden');
		$('#step2').addClass('hidden');
		$('#accountExistsError').removeClass('hidden');
		$('#registerNowBox').addClass('hidden');
		}
	} else if(form.attr('id') === 'profileContactForm') {
		var btn = $('#submit_profileContactForm'), item, parent;
		btn.removeClass('ui-btn-primary btn-primary')
			.addClass('ui-btn-warning btn-warning')
			.html('<span class="fa fa-exclamation-triangle"></span>&nbsp;<span class="title"> Fehler!</span>');
		setTimeout(function(){
			btn.removeClass('ui-btn-warning btn-warning')
				.addClass('ui-btn-primary btn-primary')
				.html('<span class="title"> Speichern</span>');
		},3000);
		if(data.responseJSON.errors.fields !== undefined) {
			$.each(data.responseJSON.errors.fields, function(i,e){
				item = $('#' + i);
				parent = item.closest('.ui-form-group');
				parent.addClass('ui-has-error ui-has-feedback');
				parent.append('<span class="fa fa-exclamation ui-form-feedback" aria-hidden="true"></span><span class="ui-help ui-error">'+e+'</span>');
			});
		}
	}
}
